import { FC, Fragment } from "react";
import { isEmpty } from "lodash";
import {
  OverlayView,
  InfoWindowF,
  MarkerF,
  OverlayViewF
} from "@react-google-maps/api";
import {
  MapObjectCard,
  ObjectMetadataTags,
  utils
} from "@vilocnv/allsetra-core";
import { MarkerBlip, MarkerLabel } from "../Map/Map.styled";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

interface MarkerProps {
  objects: any;
  selectedMarker: number | null;
  handleMarkerClick: (markerIndex: any) => void;
}

const Markers: FC<MarkerProps> = ({
  objects,
  selectedMarker,
  handleMarkerClick
}) => {
  const { t } = useTranslation();
  return (
    <Fragment>
      {objects.map((object: any, index: number) => {
        if (isEmpty(object?.location)) return null;

        const position = {
          lat: object.location.latitude,
          lng: object.location.longitude
        };

        const hasAlarmType = object.hasOwnProperty("alarmType");

        const iconUrl = !hasAlarmType ? object?.objectType?.icon?.url : "";

        const originalDate = object.location.date;
        const formattedDate = originalDate
          ? DateTime.fromISO(originalDate).toFormat("MMM dd, HH:mm a")
          : "N/A";

        const getPixelPositionOffset = () => ({
          x: 20,
          y: -29
        });

        return (
          <Fragment key={index}>
            <MarkerF
              position={position}
              icon={
                iconUrl
                  ? utils.toGoogleMapsIcon({
                      url: iconUrl,
                      scaledSize: utils.getMapSize(28, 28)
                    })
                  : undefined
              }
              onClick={() => handleMarkerClick(index)}
            >
              {selectedMarker === index && (
                <InfoWindowF onCloseClick={() => handleMarkerClick(null)}>
                  <MapObjectCard
                    // objectIcon={iconUrl}
                    label={object.name || t("typography.na")}
                    id={object.aNumber || t("typography.na")}
                    location={{
                      isLoading: false,
                      address: object?.location?.resolvedAddress,
                      latitude: object?.location?.latitude,
                      longitude: object?.location?.longitude
                    }}
                    accuracy={object.location.accuracy || t("typography.na")}
                    time={formattedDate}
                    translator={t}
                  >
                    <ObjectMetadataTags translator={t} object={object} />
                  </MapObjectCard>
                </InfoWindowF>
              )}
            </MarkerF>
            <OverlayViewF
              position={position}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
              getPixelPositionOffset={getPixelPositionOffset}
            >
              <MarkerLabel>{object.name || "N/A"}</MarkerLabel>
              <MarkerBlip></MarkerBlip>
            </OverlayViewF>
          </Fragment>
        );
      })}
    </Fragment>
  );
};

export default Markers;
